export default __webpack_public_path__ + "static/1006-59a9734a4bb2f0d1d98f41700c542388.gif";